export default __webpack_public_path__ + "static/media/mainz_dark.edffd56d.png";